export enum HttpRequestEvent {
  success = 'success',
  failure = 'failure',
  abort = 'abort',
}
